import axios from 'axios';
import { apiUrl } from './settings';
// I've changed the way API service is done because at some point I need to reset authAPI to retrieve token again (after successful login)
var getAuthAPI = function () { return axios.create({
    baseURL: apiUrl,
    headers: { Authorization: "Bearer " + localStorage.getItem('token') }
}); };
var API = {
    auth: getAuthAPI(),
    noAuth: axios.create({
        baseURL: apiUrl,
    })
};
export var resetAuthAPI = function () {
    API.auth = getAuthAPI();
};
export default API;



//////////////////
// WEBPACK FOOTER
// ./src/utils/services.ts
// module id = 147
// module chunks = 0